import * as Scrivito from "scrivito";
import parse from "html-react-parser";
import EventDate from "^/Components/Events/EventDate";
import I18n from "^/config/i18n";

function EventNode({ event, language }) {
  return (
    <div className="col-sm-4 event-overview__event-node mb-3">
      <div className="row mx-0 event-overview__event-data">
        <div className="p-3 col-sm-4 bg-lighter-gray text-orange event-overview__event-node--date">
          <EventDate event={event} language={language} />
        </div>
        <div className="col-md-8 p-3">
          <h3 className="m-0">{event.get("title")}</h3>
          <div className="py-2 text-orange">
            <i className="las la-map-marker me-2" />
            <span className="event-location-name">
              {parse(event.get("locationName"))}
            </span>{" "}
            {event.get("locationName") && event.get("locationRoom") && (
              <span> | </span>
            )}
            <Scrivito.ContentTag
              tag="span"
              content={event}
              itemProp="streetAddress"
              attribute="locationRoom"
            />
          </div>
          <Scrivito.LinkTag to={event}>
            <i className="las la-angle-right" /> {I18n.t("General see more")}
          </Scrivito.LinkTag>
        </div>
      </div>
      <div>
        <Scrivito.ImageTag
          content={event}
          attribute="image"
          className="img-fluid d-block"
          alt={event.get("image")?.get("alternativeText")}
          loading="lazy"
          width={event.get("image")?.metadata().get("width")}
          height={event.get("image")?.metadata().get("height")}
        />
      </div>
    </div>
  );
}

export default Scrivito.connect(EventNode);
